import MymeTypeIcon from './MymeTypeIcon.component';

export default MymeTypeIcon;
